import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body pt-0" }
const _hoisted_3 = {
  key: 0,
  class: "text-center pt-4 pb-2"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center pt-4 pb-2"
}
const _hoisted_5 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_6 = { class: "table table-sm" }
const _hoisted_7 = { class: "d-sm-none small" }
const _hoisted_8 = { class: "small d-flex justify-content-between" }
const _hoisted_9 = { class: "small d-flex justify-content-between" }
const _hoisted_10 = { class: "text-end d-none d-sm-table-cell small pe-2" }
const _hoisted_11 = { class: "text-end d-none d-sm-table-cell small pe-2" }
const _hoisted_12 = { class: "text-end pe-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("span", { class: "h5" }, [
          _createElementVNode("i", {
            class: "fa fa-exclamation-triangle fa-fw me-1",
            "aria-hidden": "true"
          }),
          _createTextVNode(" Puntos por Expirar ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.loaded == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", {
                class: "fas fa-spinner fa-spin",
                "aria-hidden": "true"
              }, null, -1),
              _createTextVNode(" Cargando... ", -1)
            ]))]))
          : (_ctx.loaded && _ctx.expiringPoints.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" No hay Puntos Próximos a Expirar ", -1),
                _createElementVNode("i", {
                  class: "far fa-smile",
                  "aria-hidden": "true"
                }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _createElementVNode("div", null, "Fecha")
                      ]),
                      _createElementVNode("th", { class: "text-center d-sm-none col-2" }, [
                        _createElementVNode("div", null, "Lado")
                      ]),
                      _createElementVNode("th", { class: "text-end d-none d-sm-table-cell" }, [
                        _createElementVNode("div", null, "Izquierdo")
                      ]),
                      _createElementVNode("th", { class: "text-end d-none d-sm-table-cell" }, [
                        _createElementVNode("div", null, "Derecho")
                      ]),
                      _createElementVNode("th", { class: "text-end" }, [
                        _createElementVNode("div", null, "Total")
                      ])
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expiringPoints, (p) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: p.date.getTime(),
                        class: "align-middle"
                      }, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(p.date.getTime())), 1),
                        _createElementVNode("td", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "me-1" }, "Izq:", -1)),
                            _createElementVNode("div", null, _toDisplayString(p.left.toLocaleString()), 1)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "me-1" }, "Der:", -1)),
                            _createElementVNode("div", null, _toDisplayString(p.right.toLocaleString()), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(p.left.toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(p.right.toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_12, _toDisplayString(p.total.toLocaleString()), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
      ])
    ])
  ]))
}